<script setup lang="ts">
import { UserMenu } from '@/features/session';
import { AppShell, IconLogo } from '@/shared/ui';

const navigation = [
  { label: 'Организации', route: { name: 'platform.organizations' } },
  { label: 'Пользователи', route: { name: 'platform.users' } },
  { label: 'Журнал входов', route: { name: 'platform.audit' } },
] as const;
</script>

<template>
  <AppShell>
    <template #header>
      <header
        class="sticky top-0 z-30 border-b border-white/8 bg-(--base-main-bg)/92 backdrop-blur-xl"
        data-pull-to-refresh-ignore
      >
        <div
          class="mx-auto flex min-h-16 w-full max-w-[1600px] flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2 sm:px-6 xl:px-8"
        >
          <RouterLink
            :to="{ name: 'platform.organizations' }"
            class="flex min-h-11 shrink-0 items-center gap-3 rounded-xl pr-2 focus-visible:ring-2 focus-visible:ring-(--base-accent-color) focus-visible:outline-none"
          >
            <IconLogo
              :width="32"
              :height="32"
              class="text-(--base-accent-color)"
            />
            <span class="flex flex-col leading-none">
              <span class="text-[15px] font-semibold tracking-tight">Mors</span>
              <span
                class="mt-1 text-[10px] font-semibold tracking-[0.18em] text-(--base-secondary-text-color) uppercase"
              >
                Platform
              </span>
            </span>
          </RouterLink>

          <nav class="order-3 flex w-full gap-1 overflow-x-auto sm:order-none sm:w-auto">
            <RouterLink
              v-for="item in navigation"
              :key="item.label"
              :to="item.route"
              class="flex min-h-11 shrink-0 items-center rounded-xl px-3.5 text-sm font-medium text-(--base-secondary-text-color) transition-colors hover:bg-white/5 hover:text-(--base-text-color) focus-visible:ring-2 focus-visible:ring-(--base-accent-color) focus-visible:outline-none"
              active-class="bg-white/8 text-(--base-text-color)"
            >
              {{ item.label }}
            </RouterLink>
          </nav>

          <div class="ml-auto">
            <UserMenu />
          </div>
        </div>
      </header>
    </template>

    <div class="border-l-2 border-(--base-accent-color)/65 pl-4 sm:pl-6">
      <RouterView />
    </div>
  </AppShell>
</template>
